// extracted by mini-css-extract-plugin
export var withIconContainer = "ExternalLink-module--withIconContainer--2iIND";
export var fluffyContainer = "ExternalLink-module--fluffyContainer--0eUEb";
export var fluffyTxt = "ExternalLink-module--fluffyTxt--0VKtw";